import type { AgentEvent } from "@/types/agent";
import type { StreamEventHandlerDeps } from "./types";
import { handleToolCallEvent } from "./toolCallHandler";
import { getToolCallResponseType, trackAgentResponse } from "../analytics";

export const createStreamEventHandler =
  (deps: StreamEventHandlerDeps) =>
  (event: AgentEvent): void => {
    if (event.type !== "text") {
      // Reset streaming message state on any non-text event so the next text chunk starts a new message.
      deps.streamingMessageIdRef.current = null;
      deps.streamingContentRef.current = "";
    }

    if (event.type === "status") {
      deps.setStatusStep(event.step);
      return;
    }

    deps.setStatusStep(null);

    if (event.type === "text") {
      deps.streamingContentRef.current += event.content;
      if (deps.streamingMessageIdRef.current === null) {
        const msg = deps.messageHistory.addTextMessage(
          "assistant",
          deps.streamingContentRef.current
        );
        deps.streamingMessageIdRef.current = msg.id;
        trackAgentResponse("default");
      } else {
        deps.messageHistory.updateMessage(deps.streamingMessageIdRef.current, {
          content: deps.streamingContentRef.current,
        });
      }
    }

    if (event.type === "tool_call") {
      handleToolCallEvent(event, deps);
      if (event.name !== "navigate" && event.name !== "navigate_and_scroll") {
        trackAgentResponse(getToolCallResponseType(event.name));
      }
    }

    if (event.type === "tool_trace") {
      deps.messageHistory.appendToolTracesToLastTextMessage(event.traces);
    }
  };
